import moment from 'moment/moment';
import { SelectOption } from 'global';

import { ReportsListingFilters } from '../../types';

export const GROUP_BY_OPTIONS: SelectOption[] = [
  { label: 'Location', value: 'location_id' },
  { label: 'Salesperson', value: 'sales_representative_id' },
];

export const REPORT_FILTERS: ReportsListingFilters = {
  search: '',
  stageName: '',
  locationId: '',
  departmentId: '',
  salesPersonId: '',
  salesManagerId: '',
  financeManagerId: '',
  isIncludeClosedDeals: false,
  to: moment().endOf('day'),
  from: moment().subtract(90, 'days').startOf('day'),
};

export const INITIAL_PAGINATION = {
  page: 1,
  perPage: 5,
};
